<div class="flex gap-2 text-xs leading-4 font-semibold">
  <div class="flex-shrink-0">Sources:</div>
  <div class="flex flex-auto flex-wrap flex-wrap gap-2">
    @for (reference of sources(); track reference.link) {
      <a
        [href]="reference.link"
        class="text-yellow-500"
        target="_blank"
        >{{ reference.title }}</a
      >

      @if (!$last) {
        <span>/</span>
      }
    }
  </div>
</div>
